if (!customElements.get('collection-banner')) {
    class CollectionBanner extends HTMLElement {
        constructor() {
            super();
            this.learnMoreButton = this.querySelector('.collection-banner__learn-more-button');
            this.learnMoreContent = this.querySelector('.collection-banner__learn-more');
            this.slides = this.querySelectorAll('.collection-banner__audio-player-song');
            this.navInfo = this.querySelector('.collection-banner__audio-player-arrow-info');
            this.nextSlideButton = this.querySelector('.collection-banner__audio-player-arrow-right');
            this.previousSlideButton = this.querySelector('.collection-banner__audio-player-arrow-left');
            this.collectionDescription = this.querySelector('.collection-description__wrapper');
            this.readMoreButton = this.querySelector('.collection-read-more-button');
            this.activeSlideIndex = 0;

            this.addEventListeners = this.addEventListeners.bind(this);
            this.audioPlayerSlideTo = this.audioPlayerSlideTo.bind(this);

            this.addEventListeners();
        }

        addEventListeners() {
            if (this.learnMoreButton) {
                this.learnMoreButton.addEventListener('click', this.handleToggleContent.bind(this));
            }

            if (this.nextSlideButton) {
                this.nextSlideButton.addEventListener('click', () => {
                    this.audioPlayerSlideTo('next');
                });
            }

            if (this.previousSlideButton) {
                this.previousSlideButton.addEventListener('click', () => {
                    this.audioPlayerSlideTo('previous');
                });
            }

            this.slides.forEach(slide => {
                const button = slide.querySelector('.collection-banner__audio-player-play button');

                button.addEventListener('click', (e) => this.triggerAudioPlayPause(e));
            });

            if (this.readMoreButton) {
              this.readMoreButton.addEventListener('click', () => {
                if (this.collectionDescription.classList.contains('reveal')) {
                  this.collectionDescription.classList.remove('reveal');
                  this.readMoreButton.textContent = 'Read more';
                } else {
                  this.collectionDescription.classList.add('reveal');
                  this.readMoreButton.textContent = 'Read less';
                }
              })
            }

            document.addEventListener('collection-banner:audio:pause', () => {
                this.slides.forEach(slide => {
                    slide.querySelector('.icon-play').classList.remove('hidden');
                    slide.querySelector('.icon-pause').classList.add('hidden');
                });
            });

            document.addEventListener('collection-banner:audio:play', () => {
                const activeTrack = document.querySelector('.player__audio.active');
                const activeSlide = document.querySelector('.collection-banner__audio-player-song.active');
                const productId = activeTrack?.dataset.product;
                const collectionBannerButton = document.querySelector(`.collection-banner__audio-player-play [data-product="${productId}"]`);
                const nextSlide = collectionBannerButton ? collectionBannerButton.closest('.collection-banner__audio-player-song') : null;

                if (activeSlide && collectionBannerButton) activeSlide.classList.remove('active');

                this.slides.forEach(slide => {
                    slide.querySelector('.icon-play').classList.remove('hidden');
                    slide.querySelector('.icon-pause').classList.add('hidden');
                });

                if (nextSlide) {
                    const nextSlideIndex = Array.from(this.slides).indexOf(nextSlide);

                    this.navInfo.textContent = `${nextSlideIndex + 1} of ${this.slides.length}`;
                    this.activeSlideIndex = nextSlideIndex;
                    nextSlide.classList.add('active');
                    nextSlide.querySelector('.icon-play').classList.add('hidden');
                    nextSlide.querySelector('.icon-pause').classList.remove('hidden');
                }
            });
        }

        triggerAudioPlayPause(e) {
            const track = e.target.closest('.player__audio');
            const productId = track.dataset.product;
            const soundbarTrackToPlay = document.querySelector(`.player__audio:not(.player__audio_collection_banner)[data-product="${productId}"] button`);
            const soundbarPauseButton = document.querySelector('.soundbar__controls [data-action="play"]');

            if (!track.querySelector('.icon-play.hidden')) {
                soundbarTrackToPlay?.click();
            } else {
                soundbarPauseButton?.click();
            }
        }

        handleToggleContent() {
            if (this.learnMoreContent.classList.contains('show')) {
                this.learnMoreButton.textContent = 'Learn More';
                this.learnMoreContent.classList.remove('show');
            } else {
                this.learnMoreButton.textContent = 'Show Less';
                this.learnMoreContent.classList.add('show');
            }
        }

        audioPlayerSlideTo(direction) {
            let nextSlideIndex = null;

            if (direction === 'next') {
                if (this.activeSlideIndex >= this.slides.length - 1) {
                    nextSlideIndex = 0;
                } else {
                    nextSlideIndex = this.activeSlideIndex + 1;
                }
            } else if (direction === 'previous') {
                if (this.activeSlideIndex === 0) {
                    nextSlideIndex = this.slides.length - 1;
                } else {
                    nextSlideIndex = this.activeSlideIndex - 1;
                }
            }

            this.slides[this.activeSlideIndex]?.classList.remove('active');
            this.slides[nextSlideIndex]?.classList.add('active');
            this.navInfo.textContent = `${nextSlideIndex + 1} of ${this.slides.length}`;
            this.activeSlideIndex = nextSlideIndex;
        }
    }

    customElements.define('collection-banner', CollectionBanner);
}
